import React from "react";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import CrisisAlertOutlinedIcon from "@mui/icons-material/CrisisAlertOutlined";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
const HomePageFeatures = () => {
  return (
    <div className="w-full bg-[#D6ECE1] pt-[60px] pb-[120px] flex justify-center items-center overflow-hidden relative">
         <div className="absolute -bottom-1 rotate-180 w-full  " data-negative="false">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none" className="h-[130px] -z-10 block relative left-1/2 transform -translate-x-1/2" style={
            {
                width:"calc(198% + 1.3px)"
            }
          } 
        >
          <path
          
            opacity="0.33" fill="#fff"
            d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
          ></path>
          <path
           
            opacity="0.66" fill="#fff"
            d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
          ></path>
          <path
             fill="#fff"
            d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
          ></path>
        </svg>{" "}
      </div>
      <div className="xl:w-[75%] w-[90%] flex items-center md:pb-20 pb-10 flex-col gap-3 text-center">
        <div className=" text-[#cfa649] text-2xl font-playfair">
          {" "}
          Our Features{" "}
        </div>
        <h2 className="text-[#17543E] text-4xl font-bold font-playfair">
          What made us special{" "}
        </h2>
        <p
          style={{
            wordSpacing: "2px",
          }}
          className="text-[#525C58] font-xl font-raleway lg:w-[45%] md:w-4/5 tracking-wide font-[400] leading-8 mt-3 mb-5"
        >
          Far far away, behind the word mountains, far from the countries
          Vokalia and Consonantia, there live the blind texts.
        </p>
        <div className="w-full flex flex-col md:flex-row mt-4 mb-2">
          <div className="md:w-1/3 w-full flex flex-col gap-4 justify-cente items-center p-4 lg:p-7">
            <div>
              <ContactMailOutlinedIcon className="text-[#cfa649] font-thin text-7xl" fontSize="72px" />
            </div>
            <h3 className="text-[22px] text-[#17543e] font-playfair font-[600]">
              World-class Teacher
            </h3>
            <p className="text-[16px] text-[#525C58] leading-8 font-raleway font-[400] ">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium.{" "}
            </p>
          </div>
          <div className="md:w-1/3 w-full flex flex-col gap-4 justify-cente items-center p-4 lg:p-7">
            <div>
              <PhoneAndroidOutlinedIcon className="text-[#cfa649] font-thin text-7xl" fontSize="72px"  />
            </div>
            <h3 className="text-[22px] text-[#17543e] font-playfair font-[600]">
              Practice On-the-go
            </h3>
            <p className="text-[16px] text-[#525C58] leading-8 font-raleway font-[400] ">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium.{" "}
            </p>
          </div>
          <div className="md:w-1/3 w-full flex flex-col gap-4 justify-cente items-center p-4 lg:p-7">
            <div>
              <DateRangeOutlinedIcon className="text-[#cfa649] font-thin text-7xl" fontSize="72px"  />
            </div>
            <h3 className="text-[22px] text-[#17543e] font-playfair font-[600]">
              Schedule Control
            </h3>
            <p className="text-[16px] text-[#525C58] leading-8 font-raleway font-[400] ">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium.{" "}
            </p>
          </div>
        </div>
        <div className="w-full flex flex-col md:flex-row mt-4 mb-6">
          <div className="md:w-1/3 w-full flex flex-col gap-4 justify-cente items-center p-4 lg:p-7">
            <div>
              <ForumOutlinedIcon className="text-[#cfa649] font-thin text-7xl"  fontSize="72px" />
            </div>
            <h3 className="text-[22px] text-[#17543e] font-playfair font-[600]">
              World-class Teacher
            </h3>
            <p className="text-[16px] text-[#525C58] leading-8 font-raleway font-[400] ">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium.{" "}
            </p>
          </div>
          <div className="md:w-1/3 w-full flex flex-col gap-4 justify-cente items-center p-4 lg:p-7">
            <div>
              <CrisisAlertOutlinedIcon className="text-[#cfa649] font-thin text-7xl" fontSize="72px" />
            </div>
            <h3 className="text-[22px] text-[#17543e] font-playfair font-[600]">
              Practice On-the-go
            </h3>
            <p className="text-[16px] text-[#525C58] leading-8 font-raleway font-[400] ">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium.{" "}
            </p>
          </div>
          <div className="md:w-1/3 w-full flex flex-col gap-4 justify-cente items-center p-4 lg:p-7">
            <div>
              <LayersOutlinedIcon className="text-[#cfa649] font-thin text-7xl"  fontSize="72px" />
            </div>
            <h3 className="text-[22px] text-[#17543e] font-playfair font-[600]">
              Schedule Control
            </h3>
            <p className="text-[16px] text-[#525C58] leading-8 font-raleway font-[400] ">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium.{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageFeatures;
